namespace RioERP.Carts {
    export interface CalculateCartProductRequest extends Serenity.ServiceRequest {
        ProductId?: number;
        CartId?: number;
        Quantity?: number;
        HasBooks?: boolean;
        HasPendrive?: boolean;
        HasCourier?: boolean;
        Specification?: number[];
    }
}
